import { render, staticRenderFns } from "./tab-new.vue?vue&type=template&id=2f02269b&scoped=true&"
import script from "./tab-new.vue?vue&type=script&lang=js&"
export * from "./tab-new.vue?vue&type=script&lang=js&"
import style0 from "./tab-new.vue?vue&type=style&index=0&id=2f02269b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f02269b",
  null
  
)

export default component.exports